import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner, Alert, Form, Button, Table, } from "react-bootstrap";
import { getFeedbackByMonthWise } from "../../api/feedbackAPI";

const EmployeeRatingList = () => {
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const date = new Date();
        const body = {
          month: date.getMonth() + 1,
          year: date.getFullYear(),
        };
        setSelectedMonth((date.getMonth() + 1).toString());
        setSelectedYear(date.getFullYear().toString());
        const response = await getFeedbackByMonthWise(body);
        if (response?.ratingsData) {
          setFilteredFeedbacks(response.ratingsData);
        }
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, []);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleFilter = async () => {
    setLoading(true);
    setError(null);

    try {
      const body = {
        month: selectedMonth ? parseInt(selectedMonth) : null,
        year: selectedYear ? parseInt(selectedYear) : null,
      };

      const response = await getFeedbackByMonthWise(body);
      if (response?.ratingsData) {
        setFilteredFeedbacks(response.ratingsData);
      }
      setLoading(false);
    } catch (error) {
      setError(error.message || "Error fetching feedbacks");
      setLoading(false);
    }
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Container>
      <Row className="my-4">
        <Col md={4}>
          <Form.Group controlId="filterMonth">
            <Form.Label>Select Month</Form.Label>
            <Form.Control
              as="select"
              value={selectedMonth}
              onChange={handleMonthChange}
            >
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="filterYear">
            <Form.Label>Select Year</Form.Label>
            <Form.Control
              as="select"
              value={selectedYear}
              onChange={handleYearChange}
            >
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Button variant="primary" onClick={handleFilter} className="w-100">
            Get Ratings
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* This will log the feedback data to the console */}
          {filteredFeedbacks?.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>USER ID</th>
                  <th>Rating</th>
                </tr>
              </thead>
              <tbody>
                {filteredFeedbacks.map((feedback) => (
                  <tr key={feedback._id}>
                    <td>
                      {`${feedback.name}` ||
                        "No Name"}
                    </td>
                    <td>{feedback.id || "No Id"}</td>

                    <td>{feedback.totalRatings || "No Rating"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Alert variant="info">
              No feedbacks found for the selected filters
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeRatingList;
